var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('div',{staticClass:"white--text"},[_c('div',{staticClass:"subheading"},[_vm._v("If this popup does not close in a moment, please close it manually")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }